/**
* @author Edgar Escobedo
* @description Convert number in formatVariable
* @updatedDate 27-01-2023
* @param {Number} number 
* @returns {String}
*/
function changeFormatNumberToShow(numberToConvert, id){
    let numberCoverted = 0
    numberToConvert = (numberToConvert && numberToConvert !== '') ? numberToConvert : 0
    switch (id > 0) {
      case Number(id) === 1:
        let valueConvert = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", }).format(numberToConvert)
        let valueNoDollar = valueConvert.replace("$", "")
        numberCoverted = valueNoDollar
        break;
      case Number(id) === 2:
        let addPoint2 = Number(numberToConvert).toFixed(2)
        numberCoverted = addPoint2
        break;
      case Number(id) === 3:
        let addPoint3 = Number(numberToConvert).toFixed(1)
        let splitnumber = addPoint3.split('.')
        let formatNumber3 = new Intl.NumberFormat("es-MX").format(splitnumber[0])
        let numberAfterPoint = splitnumber[1]
        let numberComplete = `${formatNumber3}.${numberAfterPoint}`
        numberCoverted = numberComplete
        break;
      case Number(id) === 4:
        let addPoint4 = Number(numberToConvert).toFixed(1)
        numberCoverted = addPoint4
        break;
      case Number(id) === 5:
        let formatNumber5 = new Intl.NumberFormat("es-MX").format(numberToConvert)
        numberCoverted = formatNumber5
        break;
      case Number(id) === 6:
        numberCoverted = parseInt(numberToConvert)
        break;
      default:
        break;
    }
    return numberCoverted
}

/**
* @author Edgar Escobedo
* @description Convert number in formatVariable to send to BD
* @updatedDate 27-01-2023
* @param {Number} number 
* @returns {String}
*/
function changeFormatNumberToSend(numberToConvert, id){
    let numberCoverted = 0
    numberToConvert = (numberToConvert  && numberToConvert !== '') ? numberToConvert : 0
    switch (id > 0) {
      case Number(id) === 1 || Number(id) === 2:
        let parseNumber1 = parseFloat(numberToConvert).toFixed(2)
        numberCoverted = parseNumber1
        break;
      case Number(id) === 3 || Number(id) === 4:
        let parseNumber4 = parseFloat(numberToConvert).toFixed(1);
        numberCoverted = parseNumber4
        break;
      case Number(id) === 5 || Number(id) === 6:
        numberCoverted = parseInt(numberToConvert)
        break;
      default:
        break;
    }
    return numberCoverted
}
export { changeFormatNumberToShow, changeFormatNumberToSend }